import $ from 'jquery'
import _ from 'lodash'
import globals from 'scoreboard/components/globals'

/**
 * Returns the displayed calendar period ID, if there is one. Otherwise, returns
 * null
 */
function displayedPeriodId() {
	// if the calendar period selector is visible, return the calendar period ID
	if (!_.isEmpty($('.period-display:visible'))) {
		return globals.periodId
	} else {
		return null
	}
}

export default displayedPeriodId

displayedPeriodId.__filename__ = 'components/displayed-period-id.js'
